import apiService from '../../../../../services/ApiService'

export default {
  data() {
    return {
      showFilters: false,
      showPdfOptions: false,
      includeGoalsInPdf: true,
      startMonthMenu: false,
      endMonthMenu: false,
      startMonthISO: null,
      endMonthISO: null,
      loading: false,
      pdfLoading: false,
      pdfDialog: false,
      natures: [],
      unidades: [],
      departments: [],
      allDepartments: [],
      costCenters: [],
      allCostCenters: [],
      filters: {
        unidadeId: null,
        departmentId: null,
        costCenterId: null,
        source: null,
        type: null,
        nature: '',
        startMonth: '',
        endMonth: '',
        startDate: null,
        endDate: null,
      },
      sourceOptions: [
        { text: 'Todos', value: null },
        { text: 'Custo Evitado', value: 'AvoidedCost' },
        { text: 'Ordem de Serviço', value: 'ServiceOrderCost' },
      ],
      typeOptions: [
        { text: 'Todos', value: null },
        { text: 'Recorrente', value: 0 },
        { text: 'Unitário', value: 1 },
      ],
      rawData: [],
      tableItems: [],
      summary: null,
      totalCost: 0,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      },
      pageSizes: [10, 25, 50, 100],

      tableHeaders: [
        { text: '', value: '', align: '' },
        { text: 'Fonte', value: 'source', sortable: true, align: 'center' },
        { text: 'Tipo', value: 'type', sortable: true, align: 'center' },
        { text: 'Custo', value: 'cost', sortable: true, align: 'center' },
        {
          text: 'Descrição',
          value: 'description',
          sortable: true,
          align: 'center',
        },
        { text: 'Natureza', value: 'nature', sortable: true, align: 'center' },
        { text: 'Data', value: 'date', sortable: true, align: 'center' },
      ],
      institutionId: null,
      apiService: new apiService(),
      institution: {},
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.loadReportData()
    this.getNatures()
    this.getUnidades()
    this.getDepartments()
    this.getCostCenters() // Carrega todos os centros de custo inicialmente
  },

  computed: {
    goalDiffValue() {
      const goal = this.institution.avoidedCostGoal || 0
      return this.totalCost - goal
    },
    goalDiffPercent() {
      const goal = this.institution.avoidedCostGoal || 0
      if (!goal) return 0
      return ((this.totalCost - goal) / goal) * 100
    },
    goalDiffSign() {
      return this.goalDiffValue >= 0 ? '+' : '-'
    },
  },

  methods: {
    async loadReportData() {
      this.loading = true

      const filterPayload = {
        institutionId: this.institutionId,
        unidadeId: this.filters.unidadeId || null,
        departmentId: this.filters.departmentId || null,
        costCenterId: this.filters.costCenterId || null,
        source: this.filters.source || null,
        type: this.filters.type !== null ? parseInt(this.filters.type) : 0,
        natureId: this.filters.nature || null,
        startDate: this.filters.startDate || null,
        endDate: this.filters.endDate || null,
      }

      await this.apiService
        .post('avoidedCost/getAvoidedCostsToReport', filterPayload)
        .then((response) => {
          this.rawData = response.content || []
          this.processData()
        })
        .catch((error) => {
          console.error('Erro ao carregar dados do relatório:', error)
          this.$toast.error('Erro ao carregar dados do relatório.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getNatures() {
      this.apiService
        .get(`AvoidedCostNature/list/${this.institution.id}`)
        .then((response) => {
          this.natures = response.content
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar naturezas')
        })
    },

    async getUnidades() {
      this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar unidades')
        })
    },

    async getDepartments() {
      this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.allDepartments = response.content
          this.departments = response.content
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar departamentos')
        })
    },

    async getCostCenters() {
      let endpoint
      
      if (!this.filters.unidadeId || this.filters.unidadeId === 0) {
        // Se não há unidade selecionada, buscar todos os centros de custo da instituição
        endpoint = `CostCenter/listActive/${this.institutionId}`
      } else {
        // Se há unidade selecionada, filtrar por unidade
        endpoint = `CostCenter/listActiveByUnidade/${this.institutionId}/${this.filters.unidadeId}`
      }

      this.apiService
        .get(endpoint)
        .then((response) => {
          this.allCostCenters = response.content
          this.costCenters = response.content
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar centros de custo')
        })
    },

    filterDepartmentsByUnit() {
      if (!this.filters.unidadeId) {
        this.departments = this.allDepartments
      } else {
        this.departments = this.allDepartments.filter(
          (dept) => dept.unidadeId === this.filters.unidadeId
        )
      }

      if (this.filters.departmentId) {
        const stillAvailable = this.departments.some(
          (dept) => dept.id === this.filters.departmentId
        )
        if (!stillAvailable) {
          this.filters.departmentId = null
        }
      }
    },

    filterCostCentersByDepartment() {
      if (!this.filters.departmentId) {
        this.costCenters = this.allCostCenters
      } else {
        this.costCenters = this.allCostCenters.filter(
          (cc) => cc.departmentId === this.filters.departmentId
        )
      }

      if (this.filters.costCenterId) {
        const stillAvailable = this.costCenters.some(
          (cc) => cc.id === this.filters.costCenterId
        )
        if (!stillAvailable) {
          this.filters.costCenterId = null
        }
      }
    },

    formatMonthDisplay(isoMonth) {
      if (!isoMonth) return ''
      const [year, month] = isoMonth.split('-')
      return `${month}/${year}`
    },

    getFirstDayOfMonth(isoMonth) {
      if (!isoMonth) return null
      return `${isoMonth}-01`
    },

    getLastDayOfMonth(isoMonth) {
      if (!isoMonth) return null
      const [year, month] = isoMonth.split('-')
      const lastDay = new Date(year, month, 0).getDate()
      return `${isoMonth}-${String(lastDay).padStart(2, '0')}`
    },

    saveStartMonth(value) {
      this.startMonthISO = value
      this.filters.startMonth = this.formatMonthDisplay(value)
      this.filters.startDate = this.getFirstDayOfMonth(value)
      this.startMonthMenu = false
    },

    saveEndMonth(value) {
      this.endMonthISO = value
      this.filters.endMonth = this.formatMonthDisplay(value)
      this.filters.endDate = this.getLastDayOfMonth(value)
      this.endMonthMenu = false
    },

    processData() {
      let data = [...this.rawData]

      data = data.map((item) => ({
        ...item,
        source:
          item.source === 'AvoidedCost'
            ? 'Cadastro Manual'
            : 'Ordem de Serviço',
        type:
          item.type === 'Recurrent'
            ? 'Recorrente'
            : item.type === 'Unitary'
            ? 'Unitário'
            : item.type === 'AvoidedCost'
            ? 'Ordem de Serviço'
            : item.type,
        description: item.description || 'Sem descrição',
        nature: item.nature || 'Não informado',
        date: item.date ? this.formatDate(item.date) : '-',
      }))

      this.pagination.totalItems = data.length
      this.pagination.totalPages = Math.ceil(
        data.length / this.pagination.pageSize
      )

      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      const end = start + this.pagination.pageSize
      this.tableItems = data.slice(start, end)

      this.totalCost = data.reduce((sum, item) => sum + (item.cost || 0), 0)
    },

    applyFilters() {
      if (this.startMonthISO && this.endMonthISO) {
        if (this.startMonthISO > this.endMonthISO) {
          this.$toast.error('O mês inicial não pode ser posterior ao mês final')
          return
        }
      }

      this.pagination.currentPage = 1
      this.loadReportData()
    },

    resetFilters() {
      this.filters = {
        unitId: null,
        departmentId: null,
        costCenterId: null,
        source: null,
        type: null,
        nature: '',
        startMonth: '',
        endMonth: '',
        startDate: null,
        endDate: null,
      }
      this.startMonthISO = null
      this.endMonthISO = null
      this.pagination.currentPage = 1

      this.departments = this.allDepartments
      this.costCenters = this.allCostCenters

      this.loadReportData()
    },

    generatePDF() {
      this.pdfDialog = true
    },

    async confirmGeneratePDF(includeGoals) {
      this.pdfDialog = false
      this.pdfLoading = true

      try {
        const filterPayload = {
          institutionId: this.institutionId,
          unidadeId: this.filters.unitId || null,
          departmentId: this.filters.departmentId || null,
          costCenterId: this.filters.costCenterId || null,
          source: this.filters.source || null,
          type: this.filters.type !== null ? parseInt(this.filters.type) : 0,
          natureId: this.filters.nature || null,
          startDate: this.filters.startDate || null,
          endDate: this.filters.endDate || null,
          includeGoals: includeGoals,
        }

        const response = await this.apiService.post(
          'avoidedCost/GenerateAvoidedCostsPdf',
          filterPayload
        )

        if (
          !response ||
          response.statusCode !== 200 ||
          !response.content?.pdf
        ) {
          this.$toast.error('Erro ao gerar PDF.')
          return
        }

        const byteCharacters = atob(response.content.pdf)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        const dateStr = new Date().toISOString().split('T')[0]
        link.setAttribute(
          'download',
          `RelatorioCustosEvitados-${this.institution.name}-${dateStr}.pdf`
        )
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        this.$toast.success('PDF gerado! Já pode abrir 📄')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        this.$toast.error('Erro ao gerar PDF.')
      } finally {
        this.pdfLoading = false
      }
    },

    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    },

    formatDate(date) {
      if (!date) return '-'
      if (typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
        return date
      }
      try {
        const cleanDate = date.replace(/(\.\d{3})\d+/, '$1')
        return new Date(cleanDate).toLocaleDateString('pt-BR')
      } catch (error) {
        return '-'
      }
    },

    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    },

    formatDate(date) {
      if (!date) return '-'
      if (typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
        return date
      }
      try {
        const cleanDate = date.replace(/(\.\d{3})\d+/, '$1')
        return new Date(cleanDate).toLocaleDateString('pt-BR')
      } catch (error) {
        return '-'
      }
    },
  },

  watch: {
    'pagination.currentPage'() {
      this.processData()
    },
    'pagination.pageSize'() {
      this.pagination.currentPage = 1
      this.processData()
    },
    'filters.unitId'() {
      this.filters.unidadeId = this.filters.unitId
      this.filterDepartmentsByUnit()
      this.filterCostCentersByDepartment()
      this.getCostCenters()
    },
    'filters.unidadeId'() {
      this.getCostCenters() // Sempre chama getCostCenters para atualizar a listagem
    },
    'filters.departmentId'() {
      this.filterCostCentersByDepartment()
    },
  },
}
